class CartDrawerRemove extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-notification').updateQuantity(this.dataset.index, 0,undefined, this.getAttribute('data-addon')); 
       // remove custom offers
      window.CUSTOM_OFFERS.updateBoGoOffer(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemove)

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notificationWrapper = document.getElementById('cart-notification-wrapper');
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.cartBubble = document.getElementById('cart-icon-bubble');
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-notification__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.cartBubble.addEventListener('click', function(e){
      e.preventDefault();
      setTimeout(function(){
        document.querySelector('cart-notification').open();
      }, 100);    
    });

    this.debouncedOnChange = debounce((event) => {
      //Prevent onchange event when message values are updated
      if(event.target.name.indexOf('attributes') >=0) { return; }

      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.querySelector('.cart-notification__message .button').addEventListener('click', function(){
      this.closest('details').removeAttribute('open');
    });
  }

  onChange(event) { 
    let giftItemkey = null, giftItemId = null;
    let dataAddOnIds = event.target.dataset.index;
    let element = document.getElementById('cart-notification-product-' + dataAddOnIds);
      if(element && element.dataset){
        if(element.dataset.addon) giftItemkey = element.dataset.addon;
      }
    if(event.target.name.indexOf('gift-wrap') >= 0){
      if (event.target.checked) {
        this.addProductFromSideCart(event.target.dataset.giftId, event.target.dataset.quantity, event.target.dataset.itemKey, true);
      }else {
        // let el = document.querySelector('#cart-notification-product-' + event.target.dataset.content);
        let dataAddOnId = event.target.dataset.content;
        let el = document.getElementById('cart-notification-product-' + dataAddOnId);
        console.log(el)        
        document.querySelector('.floating-icons .gokwik-checkout button .btn-text').textContent = document.querySelector('#cart-notification-links .gokwik-checkout .btn-text').textContent;
        this.updateQuantity(el.getAttribute('id').replace('cart-notification-product-', ''), 0, document.activeElement.getAttribute('name'),dataAddOnId);
      }
    } else {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'),giftItemkey);   
      // update custom offers
      window.CUSTOM_OFFERS.updateBoGoOffer(event.target.dataset.index, event.target.value);
    }    
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notificationWrapper.classList.add('active');
    document.querySelector('html').classList.add('cart--open');
    document.body.classList.add('cart--open');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
    // document.querySelector('.floating__checkout-btn').textContent = document.querySelector('#cart-notification-links button[name="checkout"]').textContent;
    // if(document.querySelector('#cart-notification-links button[name="checkout"]').disabled) {
    //   document.querySelector('.floating__checkout-btn').classList.add('disabled');
    // } else {
    //   document.querySelector('.floating__checkout-btn').classList.remove('disabled');
    // }
  }

  close() {
    this.notification.classList.remove('active');
    this.notificationWrapper.classList.remove('active');
    document.querySelector('html').classList.remove('cart--open');
    document.body.classList.remove('cart--open');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.afterCartCreatedOperations()

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-notification-heading'
      },
      {
        id: 'cart-notification-messages'
      },
      {
        id: 'cart-notification-links'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateQuantity(line, quantity, name,dataAddon) {
    document.getElementById('cart-notification').classList.add('cart-loading');
    let formData = {updates: {}};
    formData.updates[line] = quantity;
    if (dataAddon && dataAddon.length){ 
      formData.updates[dataAddon] = quantity;
    }
    formData.sections = this.getSectionsToRender().map((section) => section.id);
    formData.sections_url = window.location.pathname;
    // console.log(formData)
    let thisItem = document.querySelector('.cart-item[id*="'+ line +'"]')
    if(thisItem.dataset.itemTs) {
      document.querySelectorAll('.cart-item[data-item-ts="'+ thisItem.dataset.itemTs +'"]').forEach(function(el, index){
        formData.updates[el.getAttribute('id').replace('cart-notification-product-', '')] = quantity;
      });
    }
    
    document.querySelectorAll('.cart-item[data-item-key*="'+ line +'"]').forEach(function(el, index){
      formData.updates[el.getAttribute('id').replace('cart-notification-product-', '')] = quantity;
      formData.updates[el.getAttribute('data-item-key').replace('gift-box-', '')] = quantity;
    });
    
    console.log(formData,'sss')
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);        
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));

        document.querySelectorAll('#cart-notification-product .cart-item').forEach(function(el, index){
          let key = el.getAttribute('data-item-key');
          let product = document.getElementById(key);
          // console.log(product);
          if(product){
            product.checked = true;
          }
        });

        this.afterCartCreatedOperations();

        if(parsedState.item_count === 0) {
          document.querySelector('.floating-icons .gokwik-checkout').classList.add('hidden');
        } else {
          document.querySelector('.floating-icons .gokwik-checkout button .btn-text').textContent = document.querySelector('#cart-notification-links .gokwik-checkout .btn-text').textContent;
          document.querySelector('.floating__checkout-btn').classList.remove('hidden');
          // document.querySelector('.floating__checkout-btn').textContent = document.querySelector('#cart-notification-links button[name="checkout"]').textContent;
          if(document.querySelector('#cart-notification-links button[name="checkout"]').disabled) {
            document.querySelector('.floating__checkout-btn').classList.add('disabled');
          } else {
            document.querySelector('.floating__checkout-btn').classList.remove('disabled');
          }
        }
        document.getElementById('cart-notification').classList.remove('cart-loading');
      }).catch(() => {
        document.getElementById('cart-notification').classList.remove('cart-loading');
        if(document.querySelector('#cart-notification-links .gokwik-checkout button').hasAttribute('disabled')){
          document.querySelector('.floating-icons .gokwik-checkout button').setAttribute('disabled','disabled');
        } else {
          document.querySelector('.floating-icons .gokwik-checkout button').removeAttribute('disabled');
        }
      });
  }

  addProductFromSideCart(variant_id, quantity, item_id, gift) {
    document.getElementById('cart-notification').classList.add('cart-loading');
    
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
console.log(variant_id)
    const formData = new FormData();
    formData.append('id[]', variant_id);
    formData.append('quantity', quantity);
    formData.append('properties[_gift_wrap_item_id]', item_id);
    // formData.append('properties[_attached_product]', line);
    formData.append('sections', this.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    // this.getSectionsToRender().map((section) => console.log(section.id))
    for (var value of formData.values()) {
      // console.log(value);
    }
    
    config.body = formData;      

    // console.log(config);
    // return false;
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        this.renderContents(response);
        document.querySelectorAll('#cart-notification-product .cart-item').forEach(function(el, index){
          let key = el.getAttribute('data-item-key');
          let product = document.getElementById(key);
          // console.log(product);
          if(product){
            product.checked = true;
          }
        });
        
        document.getElementById('cart-notification').classList.remove('cart-loading');
        document.querySelector('.floating-icons .gokwik-checkout button .btn-text').textContent = document.querySelector('#cart-notification-links .gokwik-checkout .btn-text').textContent;
        console.log('added to cart');
      })
      .catch((e) => {
        console.error(e);
        document.getElementById('cart-notification').classList.remove('cart-loading');
      })
      .finally(() => {
        document.getElementById('cart-notification').classList.remove('cart-loading');
        // submitButton.classList.remove('loading');
        // submitButton.removeAttribute('aria-disabled');
        // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }

  afterCartCreatedOperations() {
    let allCustomBoxDetailsElements = document.querySelectorAll('custom-box-details');

    allCustomBoxDetailsElements.forEach((el, i) => {
      let data = JSON.parse(el.dataset.details);
      let title = '';
      data.forEach(element => {
        if(title != element.title) {
          let p = document.createElement('p');      
          p.innerHTML = `${element.title}`;      
          el.append(p);
          title = element.title;
        }      
        let span = document.createElement('span');
        span.innerHTML = `${element.name} <span>${element.price} x ${element.qty}</span>`;
        el.append(span);
      });
    });

    let allCustomBoxMessage = document.querySelectorAll('custom-box-message');
    allCustomBoxMessage.forEach((el, i) => {
      let data = JSON.parse(el.dataset.message);
      if(data["To"] !== "" || data["From"] !== "" || data["Message"] !== "") {
        el.classList.remove('hidden');
        el.querySelector('.message').innerHTML = data["Message"];
        el.querySelector('.to').innerHTML = data["To"];
        el.querySelector('.from').innerHTML = data["From"];
      }
    });
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
